module.exports = __webpack_public_path__ + "static/media/pic6.99b444e2.png";